/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectCategoriesQuery } from '../../models/get-project-categories-query';
import { GetProjectCategoriesQueryResult } from '../../models/get-project-categories-query-result';

export interface ApiProjectCategoriesGetProjectCategoriesPost$Params {
  
    /**
     * The query parameters to fetch the Project Categories.
     */
    body?: GetProjectCategoriesQuery
}

export function apiProjectCategoriesGetProjectCategoriesPost(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesGetProjectCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectCategoriesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesGetProjectCategoriesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectCategoriesQueryResult>;
    })
  );
}

apiProjectCategoriesGetProjectCategoriesPost.PATH = '/api/ProjectCategories/GetProjectCategories';
